import apiClient from '@/services/axios'
import { notification } from 'ant-design-vue'

const wheelApiUrl = process.env.VUE_APP_WHEEL_API_URL

const getCurrentWheel = async (wheelId, toggleLoading = () => {}) => {
  try {
    toggleLoading(true)
    const url = `${wheelApiUrl}/admin/wheels/${wheelId}`
    const response = await apiClient.get(url)
    if (response?.data?.success) {
      return response.data.data
    }
    return null
  } catch (e) {
    notification.error({
      message: e?.message ? e.message : 'Error',
    })
  } finally {
    toggleLoading(false)
  }
}

export { getCurrentWheel }
